<template>
  <DefaultLayout>
    <template #sidebar>
      <SidebarMenu/>
    </template>
    <template #main>
      <router-view/>
    </template>
  </DefaultLayout>
</template>
<script>
import {DefaultLayout} from "@dt-ecosystem/ui/packages/vue2/dist/index"
import SidebarMenu from "./components/SidebarMenu.vue"

export default {
  components: {
    DefaultLayout,
    SidebarMenu
  }
}
</script>
<style>
@media (max-width: 500px) {
  .main {
    padding-bottom: 56px !important;
  }
}
</style>
